// Interface for the API data structure for a User
import { OrganizationMembership } from "./organization-membership";
import { Coach } from "./coach";
import { Athlete } from "./athlete";
import { Guest } from "./guest";

export interface UserData {
  id?: number;
  langId?: number;
  email?: string;
  isAdmin?: number;
  active?: number;
  firstName?: string;
  lastName?: string;
  avatar?: string;
  intro?: string;
  phoneNumber?: string;
  validateDate?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  rights?: string[];

  coach?: Coach;
  athlete? : Athlete;
  guest? : Guest;

  organizationMemberships?: OrganizationMembership[];

}


export class User {
  public static readonly RIGHTS = {
    VIEW: 'view',
    EDIT: 'edit',
    DELETE: 'delete',
    CHANGE_COACHES: 'changeCoaches',
    CHANGE_TEAMS: 'changeTeams',
    WRITE_COMMS: 'writeComms',
    CHAT: 'chat',
    SEND_INVITATION: 'sendInvitation',
    ASSIGN: 'assign',
    DUPLICATE: 'duplicate',
    ACTIVE: 'active',
  }

  public static getNonTranslatableFields(): string[] { return ['id', 'langId', 'email', 'isAdmin', 'active', 'firstName', 'lastName', 'avatar', 'intro', 'phoneNumber', 'validateDate', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'langId', 'email', 'isAdmin', 'status', 'active', 'lastName', 'avatar', 'intro', 'phoneNumber', 'validateDate', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  langId?: number;
  email?: string;
  isAdmin?: number;
  active?: number;
  firstName?: string;
  lastName?: string;
  avatar?: string;
  intro?: string;
  phoneNumber?: string;
  validateDate?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  rights?: string[];

  coach?: Coach;
  athlete? : Athlete;
  guest? : Guest;

  organizationMemberships: OrganizationMembership[];


  // Static factory method to create a User instance from API data
  public static fromAPI(data: UserData): User {
    if (data.coach) {
      data.coach = Coach.fromAPI(data.coach);
    }
    if (data.athlete) {
      data.athlete = Athlete.fromAPI(data.athlete);
    }
    if (data.guest) {
      data.guest = Guest.fromAPI(data.guest);
    }
    if (data.organizationMemberships) {
      data.organizationMemberships = OrganizationMembership.fromAPIList(data.organizationMemberships);
    }
    return new User(data);
  }

  // Method to convert a list of UserData objects to User instances
  public static fromAPIList(data: UserData[]): User[] {
    return data.map((item) => User.fromAPI(item));
  }

  constructor({id,langId,email,isAdmin,active,firstName,lastName,avatar,intro,phoneNumber,validateDate,createDate,createrId,updateDate,updaterId,deleteDate,deleterId,
                rights, organizationMemberships = [], coach, athlete, guest}: UserData) {
    this.id = id;
    this.langId = langId;
    this.email = email;
    this.isAdmin = isAdmin;
    this.active = active;
    this.firstName = firstName;
    this.lastName = lastName;
    this.avatar = avatar;
    this.intro = intro;
    this.phoneNumber = phoneNumber;
    this.validateDate = validateDate;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
    this.rights = rights;

    this.coach = coach;
    this.athlete = athlete;
    this.guest = guest;

    this.organizationMemberships = organizationMemberships;
  }

  // Optionally, if a toJson method is needed
  public toJson(): object {
    return {
      id: this.id,
      langId: this.langId,
      email: this.email,
      isAdmin: this.isAdmin,
      active: this.active,
      firstName: this.firstName,
      lastName: this.lastName,
      avatar: this.avatar,
      intro: this.intro,
      phoneNumber: this.phoneNumber,
      validateDate: this.validateDate,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
  //
  // // check if the user has a specific right
  // public hasRight(right: string): boolean {
  //   return this.rights?.includes(right) ?? false;
  // }
}
